import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Content = styled.div`
  width: 1024px;
`
export const DescriptionWrapper = styled.div`
  font-size: ${theme.typography.sizes.xs};
  width: 100%;
  max-width: 100%;
`
export const TableWrapper = styled.div`
  width: 100%;
  height: 370px;
  max-height: 100%;
  margin: ${theme.spacing.lg} 0;
  overflow: auto;

  ::-webkit-scrollbar {
    width: ${theme.spacing.sm};
    height: ${theme.spacing.sm};
  }

  ::-webkit-scrollbar-thumb {
    border: none;
    background-color: ${theme.colors.neutral.light};
  }

  ::-webkit-scrollbar-track {
    background: ${theme.colors.neutral.clear};
    border-radius: ${theme.shapes.borderRadius.md};
  }
`
